import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import UserIcon from "../../../assets/user-image-plc/User_Cat.svg";
import DaniIcon from "../../../assets/dani_icon.svg";
import { marked } from "marked";
import parse from "html-react-parser";
import { Button } from "reactstrap";
import withLoading from "../../../hoc/Loading/Loading";
import { toastContainer } from "../../../utils/toast";
import moment from "moment";
import sortBy from "lodash.sortby";
import { getMessageTime } from "../../../utils/constants";
import ReactPlayer from "react-player";
import YouTubeEmbed from "../YoutubeEmbed";
import { deepClone } from "../../../utils/copyObject";
import { findLast } from "lodash";
import { IoCameraOutline } from "react-icons/io5";
import { isMobile } from "../../../utils/deviceInfo";

function UserSMSChats(props) {
  const [chats, setChats] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => {
    const phoneNumber = decodeURIComponent(props.match.params.phoneNumber);
    const date = decodeURIComponent(props.match.params.date);

    let conversationId = null;

    if(!moment(date).isValid()){
       conversationId = props.match.params.date
    }

    axios
      .post(url.getMsgHelpChatsByPhoneNumberAndDate, {
        phoneNumber: `+${phoneNumber}`,
        date: conversationId ? null : moment(date).toDate(),
        conversationId
      })
      .then(({ data }) => {
        const sorted = sortBy(data.data, (x) => x.date);
        setChats(
          sorted.filter((x) => x.response || (x.videos && x.videos.length))
        );
        scrollFunc();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props.match.params.date]);

  const createMarkup = (string) => {
    let m_down = marked.parse(string, {
      breaks: true,
    });

    return m_down;
  };

  const sanitizeDescription = (text) => {
    return text;
  };

  const renderAsHtml = (text) => {
    return parse(createMarkup(sanitizeDescription(text)));
  };

  const getAnswerFromApi = () => {
    scrollFunc();
    if (!input || (input && !input.trim())) {
      toastContainer("Please ask a question");
    }

    if(input && ["new convo","new topic","1"].includes(input.replace(/\n/g, "").toLowerCase())){
      handleNewConversationCreate();
      return
    }
    if (input && input.toLowerCase().startsWith("yes")) {
      const chatVideoMsg = findLast(
        chats,
        (x) => x.videos && x.videos.length && !x.isAdditionalDetails
      );

      if (chatVideoMsg && !chatVideoMsg.isAdditionalDetails) {
        let modifiedInput = input;
        setChats([
          ...chats,
          {
            message: input,
            response:
              "Ok, let me find you some more relevant videos on the above.",
            hideExtra: true,
          },
        ]);

        setInput("");
        axios
          .post(url.getAdditionalVideosForResponse, {
            description: modifiedInput,
            chatMessage: chatVideoMsg,
          })
          .then(({ data }) => {
            if (data.data) {
              setChats([
                ...chats.filter((x) => x.response != "SHOW_LOADER"),
                data.data,
              ]);
            }
          })
          .catch((err) => {
            console.log(err);
            toastContainer("Error while getting answer.", "error");
          });
      } else {
        toastContainer(
          "Please type another question, You cant generate videos again",
          "error"
        );
      }
    } else {
      let modifiedInput = `${input}`;
      setChats([
        ...chats,
        {
          message: input,
          response: "SHOW_LOADER",
          hideExtra: true,
        },
      ]);

      setInput("");
      const phoneNumber = `+${props.match.params.phoneNumber}`;
      const date = decodeURIComponent(props.match.params.date);

    let conversationId = null;

    if(!moment(date).isValid()){
       conversationId = props.match.params.date
    }

      axios
        .post(url.getQuestionReply, {
          Body: modifiedInput,
          From: decodeURIComponent(phoneNumber),
          requestFromWeb: true,
          conversationId
        })
        .then(({ data }) => {
          if (data.data) {
            setChats([
              ...chats.filter((x) => x.response != "SHOW_LOADER"),
              data.data,
            ]);
          }
        })
        .catch((err) => {
          console.log(err);
          toastContainer("Error while getting answer.", "error");
        });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      getAnswerFromApi();
    }
  };

  const generateVideoInstructions = (chat, chatIndex) => {
    scrollFunc();
    setChats([
      ...chats,
      {
        message: "",
        response: "Ok, let me find you some relevant videos on the above.",
        date: new Date(),
        hideExtra: true,
      },
    ]);
    axios
      .post(url.generateVideoInstructionsForAMessage, { chatMessage: chat })
      .then(({ data }) => {
        const newUpdatedChat = data.data;

        const oldChats = deepClone(chats);

        const chatIndex = oldChats.findIndex((x) => x._id == chat._id);

        if (chatIndex >= 0) {
          oldChats[chatIndex] = newUpdatedChat;

          setChats(oldChats);
        }
      })
      .catch((err) => {
        toastContainer("Error while generating video instruction", "error");
      });
  };

  const getMoreVideoInstructions = (chat) => {
    setChats([
      ...chats,
      {
        message: "",
        response: "Ok, let me find you some more relevant videos on the above.",
        hideExtra: true,
      },
    ]);
    axios
      .post(url.getMoreYoutubeVideosForResponse, {
        chatMessage: chat,
      })
      .then(({ data }) => {
        if (data.data) {
          setChats([
            ...chats.filter((x) => x.response != "SHOW_LOADER"),
            data.data,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error while getting response.", "error");
      });
  };

  const scrollFunc = () => {
    let divElement = document.getElementById("message_auto_scroll");
    divElement.scrollTop = divElement.scrollHeight + 90;
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];

    const formData = new FormData();

    formData.append("uploads", file);

    const phoneNumber = `+${props.match.params.phoneNumber}`;
    const date = decodeURIComponent(props.match.params.date);

    let conversationId = null;

    if(!moment(date).isValid()){
       conversationId = props.match.params.date
    }

    formData.append(
      "payload",
      JSON.stringify({
        phoneNumber: decodeURIComponent(phoneNumber),
        ...(conversationId && {
          conversationId
        })
      })
    );

    setChats([
      ...chats,
      {
        message: "Image uploaded",
        response: "SHOW_LOADER",
        hideExtra: true,
      },
    ]);

   
    

    axios
      .post(url.handleMessageHelpPhotoUpload, formData)
      .then(({ data }) => {
        setChats([
          ...chats.filter((x) => x.response != "SHOW_LOADER"),
          data.data,
        ]);
      })
      .catch((err) => {
        console.log(err);
        toastContainer("Error while getting response.", "error");
      });
  };

  const handleNewConversationCreate=()=>{
    const phoneNumber = `+${props.match.params.phoneNumber}`;
    axios.post(url.handleNewConversationCreate,{phoneNumber}).then(({data})=>{
      props.history.push(data.data._id)
    }).catch(err =>{
      toastContainer("Failed to create new conversation","error")
    })
  }
  return (
    <div className="">
      <div className="my-2 d-flex justify-content-center align-items-center">
         <Button color="primary" size="sm" onClick={handleNewConversationCreate}>
           New Conversation
         </Button>
         <Button color="info" className="ml-2" size="sm" onClick={()=>{
           props.history.push("all")
         }}>
           All Conversations
         </Button>
      </div>
      <div className="message-chat-page-content mb-5" id="message_auto_scroll">
        {chats.map((chat, idx) => {
          return (
            <div>
              {chat.message && (
                <div className="dani-user-step-container">
                  <div className="dani-user-step">
                    {chat.message}

                    {chat.hasImage && chat.imageUrl ? (
                      <div>
                        <img
                          src={chat.imageUrl}
                          height="300px"
                          width="200px"
                          alt=""
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <img className="dani-chat-profile-icon" src={UserIcon} />
                </div>
              )}

              {chat.message && (
                <div className="d-flex justify-content-end">
                  <span className="message-timestamp-text mr-5">
                    {" "}
                    {getMessageTime(chat.messageDate || chat.date)}{" "}
                  </span>
                </div>
              )}

              {chat.response && (
                <div>
                  <div className="dani-step-container">
                    <img
                      // style={{ marginBottom: "10px", width: "30px", marginLeft: "15px" }}
                      className="dani-chat-profile-icon"
                      src={DaniIcon}
                    />
                    <div
                      className="dani-step p-3"
                      style={{
                        position: "relative",
                      }}
                    >
                      {chat.response == "SHOW_LOADER" ? (
                        <div className="dani-load-res"></div>
                      ) : (
                        renderAsHtml(chat.response)
                      )}

                      {!chat.hideExtra && (
                        <div className="mt-3">
                          To start a new convo on a new topic or question,
                          please message "New Topic" or 1 and then type your
                          message (e.g. "new topic" or "1" + [your new
                          question]. Otherwise, feel free to ask as many
                          questions as you like.
                        </div>
                      )}

                      {idx == chats.length - 1 &&
                      !chat.hideExtra &&
                      chat.response &&
                      chat.response.length >= 200 ? (
                        // &&
                        // (!chat.videos || (chat.videos && chat.videos.length == 0))
                        <div>
                          <div
                            className="link-text mt-3"
                            onClick={() => generateVideoInstructions(chat, idx)}
                          >
                            Click here to see video instructions
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <span className="message-timestamp-text">
                    {" "}
                    {getMessageTime(chat.date)}{" "}
                  </span>
                </div>
              )}

              {chat.videos && chat.videos.length > 0 && (
                <div>
                  <div className="dani-step-container">
                    <img
                      // style={{ marginBottom: "10px", width: "30px", marginLeft: "15px" }}
                      className="dani-chat-profile-icon"
                      src={DaniIcon}
                    />
                    <div
                      className="dani-step p-3"
                      style={{
                        position: "relative",
                      }}
                    >
                      Ok, let me find you some relevant videos on the above.
                    </div>
                  </div>{" "}
                  <div className="dani-step-container">
                    <img
                      // style={{ marginBottom: "10px", width: "30px", marginLeft: "15px" }}
                      className="dani-chat-profile-icon"
                      src={DaniIcon}
                    />
                    <div
                      className="dani-step p-3"
                      style={{
                        position: "relative",
                      }}
                    >
                      {chat.videos && chat.videos.length
                        ? chat.videos.map((x, i) => (
                            <div key={i} className="my-3">
                              <h6>{x.title}</h6>

                              <div>
                                <ReactPlayer
                                  width="200px"
                                  height="150px"
                                  url={x.url}
                                  controls
                                />
                                {/* <ReactPlayer width="250px" height="150px" url="https://www.youtube.com/watch?v=dQw4w9WgXcQ" controls /> */}
                              </div>
                            </div>
                          ))
                        : ""}

                      {idx == chats.length - 1 && !chat.isAdditionalDetails ? (
                        <div>
                          If these videos are too general, If you want
                          additional videos and would like to provide more
                          description please text "yes" along with description
                        </div>
                      ) : (
                        ""
                      )}

                      {idx == chats.length - 1 && (
                        <div>
                          <span
                            className="link-text"
                            onClick={() => getMoreVideoInstructions(chat)}
                          >
                            See more videos
                          </span>
                        </div>
                      )}
                    </div>{" "}
                  </div>
                  <span className="message-timestamp-text">
                    {" "}
                    {getMessageTime(chat.videosTopicDate)}{" "}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div
        id="dani-input-message-div"
        style={{ display: "flex", bottom: "none" }}
      >
        <textarea
          name="̵comment"
          id="dani-question-input"
          rows={1}
          style={{
            color: "#54555A",
          }}
          value={input}
          placeholder="Type a message..."
          onChange={(e) => setInput(e.target.value)}
          onKeyUp={handleKeyPress}
        />
        <Button
          data-tip={"Send chat"}
          className="dani-send-question-button mr-2"
          onClick={getAnswerFromApi}
          style={{ right: isMobile?"50px": "150px", zIndex: 9999999 }}
        >
          <i className="send-icon flaticon-send"></i>
        </Button>

        <div style={{ flex: 1 }}>
          <label
            htmlFor="ai-pic--file-input"
            style={{
              marginTop: "10px",
              width: isMobile ? "30px": "150px",
              backgroundColor: "#41b6c4",
            }}
            className="create-stories singleTaskUpload actionsByStatus"
          >
            <span className={`singleTaskUpload`}>
              <IoCameraOutline />
              {
                !isMobile && " Upload Photo"
              }
             
            </span>
          </label>
          <input
            id="ai-pic--file-input"
            onChange={handleFileSelect}
            type="file"
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(withLoading(UserSMSChats, axios));
